module.exports = __webpack_public_path__ + "img/profile.63a0f109.svg";